import { AgentLiteModel } from 'api-hooks/agent';
import { PaymentChannelLiteModel } from 'api-hooks/payment-channel';
import { TourLiteModel } from 'api-hooks/tour/tour-list/tour-detail';
import { Expose, Type } from 'class-transformer';
import { PurchaseStatusEnum } from 'common/constants/enum';

import { ActivityPurchaseItemModel } from './activity';
import { PurchaseTypeEnum, SaleRelatedModel } from './common';
import { CruisePurchaseDetailModel } from './cruise';
import { HotelPurchaseItemModel } from './hotel';
import { FlightPurchaseDetailModel } from './ticket-order';
import { DocumentPurchasesModel } from './travel-document';

export class AgentCommissionPurchaseModel {
  id: string;

  accountable: string | null;

  @Expose({ name: 'accontable_type' })
  accountableType: string | null;

  @Expose({ name: 'acknowledged_at' })
  @Type(() => Date)
  acknowledgedAt: Date | null;

  @Expose({ name: 'amount' })
  @Type(() => Number)
  amount: number;

  @Expose({ name: 'description' })
  description: string | null;
}

export class PurchaseModel {
  id: string;
  number: string;
  code: string;
  description: string;
  status: PurchaseStatusEnum;
  type: PurchaseTypeEnum;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Type(() => AgentLiteModel)
  agent: AgentLiteModel;

  @Expose({ name: 'invoice_number' })
  invoiceNumber?: string | null;

  @Expose({ name: 'invoice_ref_id' })
  invoiceRefId?: string;

  @Expose({ name: 'ref_id' })
  refId?: string;

  @Expose({ name: 'payment_channel' })
  @Type(() => PaymentChannelLiteModel)
  paymentChannel: PaymentChannelLiteModel | null;

  @Type(() => TourLiteModel)
  tour: TourLiteModel | null;

  @Expose({ name: 'waiting_id' })
  waitingId: string | null;

  @Type(() => Number)
  discount: number;

  @Expose({ name: 'other_cost' })
  @Type(() => Number)
  otherCost: number;

  @Type(() => Number)
  total: number;

  @Type(() => SaleRelatedModel)
  sale: SaleRelatedModel | null;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;

  @Expose({ name: 'updated_at' })
  @Type(() => Date)
  updatedAt: Date;

  @Expose({ name: 'transaction_type' })
  transactionType: string;

  @Expose({ name: 'agent_commission' })
  @Type(() => AgentCommissionPurchaseModel)
  agentCommission: AgentCommissionPurchaseModel | null;
}

export class PurchaseDetailModel extends PurchaseModel {
  @Expose({ name: 'flight_purchases' })
  @Type(() => FlightPurchaseDetailModel)
  flightPurchases: FlightPurchaseDetailModel[];

  @Expose({ name: 'hotel_purchases' })
  @Type(() => HotelPurchaseItemModel)
  hotelPurchases: HotelPurchaseItemModel[];

  @Expose({ name: 'cruise_purchases' })
  @Type(() => CruisePurchaseDetailModel)
  cruisePurchases: CruisePurchaseDetailModel[];

  @Expose({ name: 'activity_purchases' })
  @Type(() => ActivityPurchaseItemModel)
  activityPurchases: ActivityPurchaseItemModel[];

  @Expose({ name: 'document_purchases' })
  @Type(() => DocumentPurchasesModel)
  documentPurchases: DocumentPurchasesModel[];
}
